import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { PermitService } from "../../../common/services/permit.service";
import { LandownerPassthroughProgramApplication, LandownerProgramSearchSpec, LandownerProgramStatus, PassthroughProgramWell } from "../../../common/models/permit.model";

@Component({
    selector: 'landowner-passthrough-details',
    templateUrl: './landowner-passthrough-details.component.html',
    styleUrls: ['./landowner-passthrough-details.component.scss'],
    standalone: false
})
export class LandownerPassthroughDetailsComponent implements OnInit, OnDestroy {

    @Input() apiNumber: string;

    application: LandownerPassthroughProgramApplication;
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    programInfo: string = "If a well has had multiple applications submitted and withdrawn from the program, only information from the most recent application will be shown.";

    subscription: Subscription = new Subscription();

    get wellData(): PassthroughProgramWell {
        if (this.application == null) return null;
        return this.application.passthroughProgramWell;
    }

    constructor(private service: PermitService) { }

    ngOnInit() {
        const spec = { apiNumbers: [ this.apiNumber ], programStatus: [ LandownerProgramStatus.Active, LandownerProgramStatus.Plugged ], includeStatusAndDisposition: false } as LandownerProgramSearchSpec;
        const dataSubs$ = this.service.searchLandownerPassthroughApplications(spec).pipe(
            map((data: LandownerPassthroughProgramApplication[]) => {
                return data.sort((a, b) => {
                    if (a.dateCreated < b.dateCreated) return -1;
                    if (a.dateCreated > b.dateCreated) return 1;
                    return 0;
                });
            })
        ).subscribe(
            (results: LandownerPassthroughProgramApplication[]) => {
                if (results.length > 0) this.application = results[0]; //display data only from the most recent
                this.loading.next(false);
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(dataSubs$);
    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }
}
